import React, { useContext } from 'react';
import Modal from 'components/modal';
import Carousel from 'components/carousel/carousel';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import { ProductInterface } from 'interfaces/product.interface';
import { useModal } from 'hooks/use-modal';

import './product-photo.scss';

const ProductModalCarouselDesktop = React.lazy(() => import('components/product/product-modal-carousel'));

interface ProductPhotoProps {
    modalIsOpen: boolean;
    product: Pick<ProductInterface, 'name' | 'photos' | 'attributes' | 'price' | 'offers'>;
    emulateTouch: boolean;
    hasProducerArea?: boolean;
}

const ProductPhoto: React.FC<ProductPhotoProps> = props => {
    const api = useContext(TeApiContext);
    const { isOpen: modalIsOpen, open: loadModal, close: closeModal } = useModal('PHOTO_CAROUSEL');

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isMobile = api.getDevice() === 'mobile';

    return (
        <div className={`product-photo${isMobile ? ' product-photo--mobile' : ''}${props.hasProducerArea ? ' product-photo--mobile-area' : ''}`}>
            <Carousel
                alt={props.product.name}
                title={props.product.name}
                photos={props.product.photos.items}
                emulateTouch={props.emulateTouch}
                onClick={loadModal}
                showThumbs={false}
                showArrows={!isMobile}
            />
            {
                modalIsOpen && (
                    <Modal
                        showCloseIcon={true}
                        center={true}
                        isOpen={true}
                        onClose={closeModal}
                        shouldCloseOnOverlayClick={!isMobile}
                        modalClassName="photo-modal-carousel"
                    >
                        <ProductModalCarouselDesktop emulateTouch={false} closeModal={closeModal} product={props.product}/>
                    </Modal>
                )
            }
        </div>
    );
};

export default ProductPhoto;
